export const STEP_TESTS_FEATURE_FLAG = "step-tests";
export const WORKFLOW_CODE_SEARCH_FLAG = "workflow-code-search";

// Gates OAuth apps acting as service accounts: the OAuth apps registry, the
// per-service-account app authorization UI, and the service-account-bound token
// issuance path in the authorization server. The MCP OAuth server itself is
// always on (its flag was dropped); this flag is only our SA-bound extension.
export const OAUTH_SERVICE_ACCOUNTS_FEATURE_FLAG = "oauth-service-accounts";

// Gates the one-time new-user intro video modal shown on first arrival; off
// everywhere until enabled.
export const NEW_USER_INTRO_VIDEO_FEATURE_FLAG = "3b-new-user-intro-video";
// Gates the request-to-share flow: a user who can configure a connector but
// lacks tenant:connected_app_share can submit the access they composed as a
// pending request for a Connector Sharer or admin to approve.
export const REQUEST_CONNECTOR_SHARE_FLAG = "request-connector-share";

// Gates the baseline CSP the public service adds to the html-viewer harness
// and to step-authored HTML responses, a second defense layer next to the
// iframe sandbox attribute.
export const PUBLIC_CONTENT_CSP_FEATURE_FLAG = "public-content-csp";

// Gates the settings toggle for the tenant-wide public/external-id route
// auth kill switch. Enforcement of an already-set kill switch is not gated.
export const PUBLIC_ROUTE_AUTH_KILL_SWITCH_FLAG =
  "public-route-auth-kill-switch";

// Gates extracting a pinned run's recorded requests into a `.requests`
// fixture file. Independent of STEP_TESTS_FEATURE_FLAG (which gates pinning
// itself) because until the replay engine lands, a step-test run or capture
// that replays those fixtures would try to make the request for real and
// fail hermetically — off keeps pinning steps with real egress working as
// it did before request fixtures existed.
export const STEP_TEST_REQUEST_FIXTURES_FLAG = "step-test-request-fixtures";

// Gates the connector usage monitoring surface: the Connectors tab in
// Monitoring and the modal's activity, pricing, and limits sections.
export const CONNECTOR_USAGE_MONITORING_FLAG = "connector-usage-monitoring";

// Gates the in-app Intercom support messenger — the Support menu item's
// messenger behavior and the mounted IntercomMessenger; off falls back to the
// contact link. Layered on top of the deployment-level config.intercomAppId, so
// it only takes effect where Intercom is configured (all SaaS tenants share one
// workspace), letting us roll the messenger out per tenant.
export const INTERCOM_SUPPORT_FEATURE_FLAG = "intercom-support";

// Gates the chat model experiment: each user is deterministically assigned a
// managed chat model as their default, and end-of-session thumbs feedback and
// mid-conversation model switches are reported to Sentry.
export const MODEL_EXPERIMENT_FLAG = "model-experiment";
